import { createHTML, organizeOccurrences } from "./utils";

export function exportPDF(
    occurrences,
    attributeForOrganize,
    includeUndefined,
    beautifulName,
    fileName = 'Relatório Conecta Canaã',
    includeServiceStart = false,
    includeResolutionTime = false
) {
    var iframe = document.createElement('iframe');

    const organizedOccurrences = organizeOccurrences(occurrences, attributeForOrganize, includeUndefined);

    const body = createHTML(
        organizedOccurrences,
        fileName,
        occurrences.length,
        beautifulName,
        includeServiceStart,
        includeResolutionTime
    );

    const lastName = document.title;
    document.title = fileName;

    iframe.width = "100%";
    iframe.setAttribute("srcdoc", body);
    iframe.style.display = 'none';

    const bodyElement = document.getElementsByTagName("body")[0];
    bodyElement.appendChild(iframe);

    iframe.contentWindow.print();

    setTimeout(() => { document.title = lastName; }, 100);
}